<!--
    描述：新增、编辑人员弹框等
    时间：2020-04-22
    Created by yefan
-->
<template>
	<div class="h100 add-user-main">
		<el-form :model="userForm"
				 :rules="userRules"
				 ref="userForm"
				 label-width="100px">
			<el-row>
				<el-col :span="22"
						:offset="1">
					<el-form-item label="姓名"
								  prop="sname"
								  :show-message="false">
						<el-input v-model="userForm.sname"
								  :disabled="isDisabled"
								  autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22"
						:offset="1">
					<el-form-item label="用户名"
								  prop="username"
								  :show-message="false">
						<el-input v-model="userForm.username"
								  :disabled="isDisabled"
								  autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22"
						:offset="1">
					<el-form-item label="上级"
								  prop="superior">
						<el-input v-model="userForm.superior"
								  autocomplete="off"
								  disabled
								  :show-message="false">
							<el-button slot="append"
									   icon="el-icon-plus"
									   :disabled="isDisabled"
									   @click="addSupplior()"></el-button>
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22"
						:offset="1">
					<el-form-item label="岗位"
								  prop="stationId">
						<el-select v-model="userForm.stationId"
								   :disabled="isDisabled"
								   placeholder="请选择">
							<el-option v-for="(item, index) in stationList"
									   :key="'类型' + index"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22"
						:offset="1">
					<el-form-item label="账号状态"
								  prop="isFlag">
						<el-switch v-model="userForm.isFlag"
								   class="switch"
								   active-text="启用"
								   inactive-text="禁用"
								   :active-value="1"
								   :inactive-value="0"
								   active-color="#2671cc"
								   inactive-color="#cccccc"
								   :disabled="isDisabled"></el-switch>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22"
						:offset="1">
					<el-form-item label="角色"
								  prop="roleIds"
								  :show-message="false">
						<tree-select v-model="userForm.roleIds"
									 :multiple="true"
									 :options="roleTreeData"
									 :disabled="isDisabled"
									 :append-to-body="true"
									 :default-expand-level="1"
									 placeholder="请选择">
						</tree-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   append-to-body
				   center>
			<!-- 弹窗组件 -->
			<superiorsTable @on-selected="handleUserSelcted"></superiorsTable>
		</el-dialog>
	</div>
</template>
<script>
import { insertSysUser, getUserInfo, getDictsByValue} from 'api/modules/user.js'
import { selectRoleTree } from 'api/modules/role.js'
import superiorsTable from './superiors_table'

export default {
	components: { superiorsTable },
	props: {
		mode: {
			type: String,
			default: () => {
				return ''
			},
		},
		userId: {
			type: String,
			default: () => {
				return null
			},
		},
	},
	data() {
		return {
			userForm: {
				sname: '',
				username: '',
				parentId: '',
				superior: '',
				stationId: '',
				isFlag: 1,
				deptId: '',
				roleIds: [],
			},
			userRules: {
				sname: [{ required: true }],
				username: [{ required: true }],
				roleIds: [{ required: true, type: 'array', trigger: 'change' }],
			},
			roleTreeData: [],
			defaultProps: {
				children: 'children',
				label: 'sname',
			},
			dialogObj: {
				title: '选择上级领导',
				visible: false,
				width: '650px',
				mode: 'add',
			},
			stationList: [],
		}
	},
	methods: {
		//点击确定按钮事件
		doSave(deptId) {
			this.$refs.userForm.validate((valid) => {
				if (valid) {
					if (deptId) this.userForm.deptId = deptId
					insertSysUser(this.userForm).then((res) => {
						res.code == 0
							? this.$message.success('保存成功！')
							: this.$message.error(res.msg)
						//点击确定后关闭弹框
						this.$emit('dialogClose')
					})
				} else {
					this.$message.warning('请完善必填项!')
				}
			})
		},

		// 获取角色数据
		getRoleData() {
			let param = {}
			selectRoleTree(param).then((res) => {
				this.roleTreeData = res.data
			})
		},

		//获取岗位
		getStationList() {
			let param = {}
			param.value = '1001002'
			getDictsByValue(param).then((res) => {
				this.stationList = res.data
			})
		},

		// 查看、编辑初始渲染数据
		initSysUser() {
			let param = {}
			param.id = this.userId
			getUserInfo(param)
				.then((res) => {
					this.userForm = res.data
				})
				.catch((err) => {})
		},

		//选择上级点击新增按钮
		addSupplior() {
			this.dialogObj.visible = true
		},

		//获取上级领导回显数据
		handleUserSelcted(obj) {
			this.dialogObj.visible = false
			this.userForm.superior = obj.sname
			this.userForm.parentId = obj.id
		},
	},
	created() {
		if (this.mode !== 'add') this.initSysUser()
		this.getRoleData()
		this.getStationList()
	},
	computed: {
		// 是否可编辑
		isDisabled() {
			return this.mode === 'view' ? true : false
		},
	},
}
</script>

<style scoped lang="less">
/*
    用scoped + /deep/ 可修改原组件样式 同时不影响全局样式
*/
/deep/ .el-input-group__prepend {
	border-right: none;
}

/deep/ .el-input-group__append {
	background-color: #409eff;
	color: #fff;
	vertical-align: middle;
	display: table-cell;
	position: relative;
	border: 1px solid #dcdfe6;
	padding: 0 20px;
	width: 1px;
	white-space: nowrap;
	border-left: none;
}
</style>
